import { PLANS_BASE_PATH_KEY } from '@cplug/frontend-subscription-hub/domain/plans'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(PLANS_BASE_PATH_KEY, '/dashboard/plans')
})
